import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";

// Web app config — get from Firebase Console → Project Settings → Your apps.
// Web API key is PUBLIC (Firebase docs explicitly say so) — safe to commit.
//
// Replace these placeholders with the real values from `dinflow-prod`.
const firebaseConfig = {
  apiKey:            "AIzaSyBKV2oS531n5xQWMRZDqh5xbl3Dkw-Vhco",
  authDomain:        "dinflow-prod.firebaseapp.com",
  projectId:         "dinflow-prod",
  storageBucket:     "dinflow-prod.firebasestorage.app",
  messagingSenderId: "109974447298",
  appId:             "1:109974447298:web:c2b5003d3cccb07cc2075b",
  measurementId:     "G-R6X67BTPQK",
};

export const app       = initializeApp(firebaseConfig);
export const auth      = getAuth(app);
export const functions = getFunctions(app, "asia-south1");
export const db        = getFirestore(app);
